import Vue from 'vue'
import ChevronLeft from 'vue-material-design-icons/ChevronLeft.vue'
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue'
import Close from 'vue-material-design-icons/Close.vue'
import Magnify from 'vue-material-design-icons/Magnify.vue'
Vue.component('chevron-left', ChevronLeft)
Vue.component('chevron-right', ChevronRight)
Vue.component('close', Close)
Vue.component('magnify', Magnify)
